import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Start",
    redirect: { name: "Einführung" }
  },
  {
    path: "/einführung/",
    name: "Einführung",
    component: () => {
      return import("../views/Einführung.vue");
    }
  },
  {
    path: "/neuevueapp/",
    name: "NeueVueApp",
    component: () => {
      return import("../views/NeueVueApp.vue");
    }
  },
  {
    path: "/ordnerstruktur/",
    name: "Ordnerstruktur",
    component: () => {
      return import("../views/Ordnerstruktur.vue");
    }
  },
  {
    path: "/appvue/",
    name: "AppVue",
    component: () => {
      return import("../views/AppVue.vue");
    }
  },
  {
    path: "/router/",
    name: "Router",
    component: () => {
      return import("../views/Router.vue");
    }
  },
  {
    path: "/viewscomponents/",
    name: "ViewsComponents",
    component: () => {
      return import("../views/ViewsComponents.vue");
    }
  },
  {
    path: "/binding/",
    name: "Binding",
    component: () => {
      return import("../views/Binding.vue");
    }
  },
  {
    path: "/dokumentation/",
    name: "Dokumentation",
    component: () => {
      return import("../views/Dokumentation.vue");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
